import { Col, Row } from "antd";
import PropTypes from "prop-types";
import React, { Children, useRef } from "react";
import Search from "../search";
import { forwardRef, useImperativeHandle } from "react";

const ActionBar = forwardRef(({ align, children, gutter, leftActions, justify, onSearch, search, searchLoading, searchOnEnterOrClick, searchFormatter }, ref) => {
  const margin = gutter.map((n) => -Math.floor(n / 2) + "px").join(" ");
  const inputRef = useRef(null);

  useImperativeHandle(ref, () => ({
    focus: () => {
      const el = inputRef.current?.input ?? inputRef.current;
      el?.focus();
    },
  }));

  return (
    <Row align={align} gutter={gutter} justify={justify} style={{ margin }}>
      {Children.toArray(leftActions).map((node, index) => (
        <Col key={"l" + index}>{node}</Col>
      ))}
      {onSearch && (
        <Col>
          <Search ref={inputRef} search={search} onSearch={onSearch} loading={searchLoading} formatter={searchFormatter} searchOnEnterOrClick={searchOnEnterOrClick} />
        </Col>
      )}
      <Col flex="1" />
      {Children.toArray(children).map((node, index) => (
        <Col key={index}>{node}</Col>
      ))}
    </Row>
  );
});

ActionBar.displayName = "ActionBar";

ActionBar.defaultProps = {
  gutter: [8, 8],
  justify: "end",
};

ActionBar.propTypes = {
  align: PropTypes.oneOf(["start", "end", "center", "space-around", "space-between"]),
  children: PropTypes.node,
  gutter: PropTypes.arrayOf(PropTypes.number),
  leftActions: PropTypes.arrayOf(PropTypes.node),
  justify: PropTypes.oneOf(["start", "end", "center", "space-around", "space-between"]),
  onSearch: PropTypes.func,
  search: PropTypes.string,
  searchLoading: PropTypes.bool,
};

export default ActionBar;
